import React from "react";
import {
  Check,
  CheckCircle,
  Tag,
  User,
  Users,
  Trash2,
  Edit3,
  Pencil,
  Settings,
  Download,
  Plus,
  Filter,
  Eye,
  EyeOff,
  Columns,
  Save,
  X,
  Calendar,
  Hash,
  Type,
  MoreHorizontal,
  Mail,
  Phone,
  Activity,
  Clock,
  Ticket,
  FileText,
  Building2,
  RefreshCw,
  Sparkles,
  Shield,
  GitMerge,
  ChevronDown,
  Zap,
  Link,
  Copy,
  MessageSquare,
  History,
} from "lucide-react";

export const getIconComponent = (
  iconName: string
): React.ComponentType<{ className?: string }> | null => {
  const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
    check: Check,
    "check-circle": CheckCircle,
    tag: Tag,
    user: User,
    users: Users,
    trash: Trash2,
    trash2: Trash2,
    edit: Edit3,
    edit3: Edit3,
    pencil: Pencil,
    settings: Settings,
    download: Download,
    plus: Plus,
    search: Filter,
    filter: Filter,
    eye: Eye,
    "eye-off": EyeOff,
    columns: Columns,
    save: Save,
    x: X,
    calendar: Calendar,
    hash: Hash,
    type: Type,
    more: MoreHorizontal,
    "more-horizontal": MoreHorizontal,
    mail: Mail,
    phone: Phone,
    activity: Activity,
    clock: Clock,
    ticket: Ticket,
    "file-text": FileText,
    building: Building2,
    building2: Building2,
    "refresh-cw": RefreshCw,
    sparkles: Sparkles,
    shield: Shield,
    "git-merge": GitMerge,
    "chevron-down": ChevronDown,
    zap: Zap,
    link: Link,
    copy: Copy,
    "message-square": MessageSquare,
    history: History,
  };

  const IconComponent = iconMap[iconName.toLowerCase()];
  return IconComponent || null;
};
